// extracted by mini-css-extract-plugin
module.exports = {"faqContainer":"Faq_faqContainer__LMUTy","faqMain":"Faq_faqMain__Ms6SA"};